import { ISession } from '../../models/pro-sites';

export const hasBucket = (session: ISession, bucket: number): boolean => {
    return session.buckets.some((r) => bucket === r);
};

export const hasBuckets = (session: ISession, buckets: number[]): boolean => {
    return session.buckets.some((r) => buckets.includes(r));
};
